import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthContext";

function PatientLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setIsAuthenticated } = useAuth(); // Access the authentication context

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (!email.trim() || !password.trim()) {
      setError("Please enter both email and password.");
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setIsAuthenticated(true); // Set authentication status to true
      navigate("/request-appointment");
    }, 800);
  };

  return (
    <div className="page-card centered-card">
      <div className="padding-lg">
        <h2 className="page-heading">Sign in to Wellness Check</h2>
        <p className="page-copy text-muted">
          Enter your credentials to access the request appointment workspace.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group spaced">
            <label className="form-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="form-control"
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="form-group spaced">
            <label className="form-label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="form-control"
              placeholder="Enter your password"
              required
            />
          </div>

          {error && <div className="alert alert-danger">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? <span className="spinner"></span> : "Sign in"}
          </button>

          {/* Forgot password + Register side by side */}
          <div className="flex-between mt-3">
            <button
              type="button"
              className="link-button"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot password?
            </button>
            <button
              type="button"
              className="link-button"
              onClick={() => navigate("/register")}
            >
              Sign up
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PatientLoginPage;
